<template>
  <div style="display: flex;">
    <div class="main-content" :style="mainContentViewHeight" style="width: 80%;">
      <pm-form-render v-if="customFormShow" ref="customFormRef"></pm-form-render>
      <!--            <customForm-->
      <!--                    v-if="customFormShow"-->
      <!--                    ref="customFormRef"-->
      <!--                    :auditHisTable.sync="auditHisTable"-->
      <!--                    :angleType.sync="angleType"-->
      <!--                    :entityId.sync="entityId"-->
      <!--                    :categoryCode.sync="categoryCode"-->
      <!--                    :baseURL.sync="baseURL"-->
      <!--                    :nodeCode.sync="nodeCode"-->
      <!--            >-->
      <!--            </customForm>-->

      <customFormOther v-if="customFormOtherShow" ref="customFormOtherRef" :auditHisTable.sync="auditHisTable"
                       :angleType.sync="angleType" :entityId.sync="entityId" :categoryCode.sync="categoryCode"
                       :nodeCode.sync="nodeCode" :nodeTitle.sync="nodeTitle" :purchaserMode.sync="purchaserMode"
                       :projectCode.sync="projectCode"></customFormOther>

<!--      &lt;!&ndash;  见证情况&ndash;&gt;-->
<!--      <witnessStatusForm-->
<!--          v-if="(witnessStatusFormList.indexOf(nodeCode) > -1) && areaBesidesCodeList.indexOf(stateData.orgInfo.regionCode) < 0"-->
<!--          ref="witnessStatusForm" :projectInfo="paramMap"></witnessStatusForm>-->

      <el-card class="box-card" v-if="!customFormShow && !customFormOtherShow"
               style="min-height: 700px;position: relative">
        <emptyInfo :emptyMsg="'暂无表单数据'"></emptyInfo>
      </el-card>


    </div>
    <div style="margin: 0 10px 0 10px;width: 20%;height: 100%">
      <div class="el-card box-card">
        <div style="text-align: center;margin:10px 0 3px 0">
                    <span @click="getFlowNode(0)" title="项目（标段）视角"
                          :class="angleType == 0 ? 'angleType active' : 'angleType'"><icon-svg name="project"
                                                                                               class="site-sidebar__menu-icon"></icon-svg></span>
          <span @click="getFlowNode(1)" title="招标人视角"
                :class="angleType == 1 ? 'angleType active' : 'angleType'"><icon-svg name="zhaobiaoren"
                                                                                     class="site-sidebar__menu-icon"></icon-svg></span>
          <span @click="getFlowNode(2)" title="招标代理视角"
                :class="angleType == 2 ? 'angleType active' : 'angleType'"><icon-svg name="zhaobiaoagent"
                                                                                     class="site-sidebar__menu-icon"></icon-svg></span>
          <span @click="getFlowNode(3)" title="投标人视角"
                :class="angleType == 3 ? 'angleType active' : 'angleType'"><icon-svg name="toubiaoren"
                                                                                     class="site-sidebar__menu-icon"></icon-svg></span>
          <span @click="getFlowNode(4)" title="评委专家视角"
                :class="angleType == 4 ? 'angleType active' : 'angleType'"><icon-svg name="pingwei"
                                                                                     class="site-sidebar__menu-icon"></icon-svg></span>
        </div>
        <div v-for="(value, key) in flowData" :key="key">
          <table class="angleWrapper">
            <tr style="height: 25px;background: #dcdfe6;">
              <td style="border: 1px solid #dcdfe6;width: 300px">{{ key }}</td>
            </tr>
            <tr v-for="item in value" :key="item.id" style="height: 25px;">
              <td v-if="item.isVisible" :class="nodeCode == item.nodeCode ? 'link active' : 'link'"
                  style="border: 1px solid #ebeef5;width: 300px;color: #005aff"
                  @click="getFormData(item)">{{ item.nodeName }}</td>
              <td v-else style="border: 1px solid #ebeef5;width: 300px;color: #8b8c9b">{{ item.nodeName }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="el-card box-card">
        <table v-if="angleType == 3"
               style="border: 1px solid #dcdfe6;border-collapse:collapse;text-align: center">
          <tr style="height: 25px;background: #dcdfe6;">
            <td style="border: 1px solid #dcdfe6;width: 300px">投标人筛选</td>
          </tr>
          <el-select v-model="paramMap.applyCode" clearable value-key="value" style="width:100%;"
                     @change="seachBtn">
            <el-option label="全部" value="-1"></el-option>
            <el-option v-for="(item, index) in applyCodeList" :key="item.id" :label="item.applyName"
                       :value="item.applyCode"></el-option>
          </el-select>
        </table>
        <table v-if="angleType == 4"
               style="border: 1px solid #dcdfe6;border-collapse:collapse;text-align: center">
          <tr style="height: 25px;background: #dcdfe6;">
            <td style="border: 1px solid #dcdfe6;width: 300px">评标专家筛选</td>
          </tr>
          <el-select v-model="paramMap.idcard" clearable value-key="value" style="width:100%;"
                     @change="seachBtn">
            <el-option label="全部" value="-1"></el-option>
            <el-option v-for="(item, index) in idcardOptionList" :key="item.id" :label="item.personName"
                       :value="item.idcard"></el-option>
          </el-select>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import emptyInfo from '@/components/empty-info';
import customForm from '@/components/customForm';
import customFormOther from '@/components/customForm/customFormOther';
import witnessStatusForm from '@/components/customForm/witnessStatusForm';

export default {
  components: {
    customForm,
    customFormOther,
    emptyInfo,
    witnessStatusForm,
  },
  props: ["mainContentViewHeight"],
  data() {
    return {
      visible: false,
      nodeCode: '',
      nodeTitle: '',
      purchaserMode: "",// 采购方式
      currentNode: {},
      // 查询附件
      categoryCode: '',
      entityId: '',
      customFormShow: true,
      angleType: 0,
      customFormOtherShow: false,
      dataId: '',
      projectCode: '',
      applyCodeList: [],
      idcardOptionList: [],
      paramMap: {
        tenderProjectCode: '',
        bidSectionCode: '',
        datasetCode: "",// 查询entityId所需参数
        categoryIsOpen: "", // 附件约束条件
        projectCode: '',
        applyCode: "",
        idcard: "",
        categoryCode: "",
      },

      bidCompany: {},
      auditHisTable: [], // 见证记录
      businessType: '',
      baseURL: '',
      tenderProjectCode: '',
      bidSectionCode: '',
      formId: '',
      groupList: [],
      formInfo: {},
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
      flowData: '',

      // 见证情况列表
      witnessStatusFormList: ['GC00001', 'GC00043', 'GC00003', 'GC00004', 'GC00044', 'GC00006', 'GC00025', 'GC00026', 'GC00027', 'GC00029', 'GC00039', 'GC00041', 'GC00040',],
      // 排除区域列表 阳新 大冶
      areaBesidesCodeList: ['420281', '420222'],
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),

  },
  activated() {
    this.paramMap = this.$route.params.paramMap || JSON.parse(window.sessionStorage.getItem("witnessHisDetailParamMap"));
    this.paramMap.applyCode = '';
    this.paramMap.idcard = '';
    this.angleType = this.$route.query.angleType ? parseInt(this.$route.query.angleType) : 0;
    this.businessType = this.$route.query.businessType || "";
    this.purchaserMode = this.$route.query.purchaserMode || "";
    this.projectCode = this.paramMap.projectCode
    this.tenderProjectCode = this.paramMap.tenderProjectCode
    this.bidSectionCode = this.paramMap.bidSectionCode

    // 智慧交易预警页面跳转所带参数
    this.flowId = (this.$route.query && this.$route.query.flowId) || (this.$route.params && this.$route.params.flowId) || '';
    this.entityId = (this.$route.query && this.$route.query.entityId) || (this.$route.params && this.$route.params.entityId) || '';

    this.getFlowNode(this.angleType);
  },
  methods: {

    //搜索按钮
    seachBtn() {
      this.getFormData()
    },

    getFormData(data) {
      this.customFormShow = false;
      this.customFormOtherShow = false;
      if (data) {
        this.currentNode = data;
        this.nodeCode = data.nodeCode;
        this.nodeTitle = data.nodeName;
        //  用来查询 附件数据 的参数
        this.categoryCode = data.categoryCode;

        this.paramMap.categoryCode = data.categoryCode;
        // 用来查询 entityId 的参数
        this.paramMap.datasetCode = data.datasetCode;
        this.paramMap.categoryIsOpen = data.categoryIsOpen;
        this.paramMap.categoryCode = data.categoryCode;
        // if (this.$refs.witnessStatusForm) {
        //   this.$refs.witnessStatusForm.getDetail(this.paramMap);
        // }
      }

      if (this.currentNode.nodeCode) {


        if (this.currentNode.isVisible == false) {
          this.customFormShow = false;
          this.customFormOtherShow = false;
          return
        }
        const that = this;
        // 支持自定义表单数据
        if (this.currentNode.enableCustom == 1) {

          this.customFormShow = true;
          this.customFormOtherShow = false;
          this.$nextTick(() => {
            this.$refs.customFormRef?.getCustomData(that.currentNode.formId, that.paramMap, {
              getAttByEntityId: true
            })
          });


        } else { // 定制化表单数据
          this.customFormShow = false;
          this.customFormOtherShow = true;
          this.$nextTick(() => {
            this.$refs.customFormOtherRef?.getCustomData(that.currentNode.formId, that.paramMap, this.currentNode.nodeCode, this.purchaserMode, true);
          });

        }


      }
    },



    getFlowNode(angleType) {
      console.log(angleType)
      this.angleType = angleType;
      if (angleType !== '' && this.businessType !== '') {

        // 获取视角节点
        this.$http({
          url: '/configs/sysFlowNodeConfig/bulidFlownodeTree?projectCode=' + this.projectCode + '&tenderProjectCode=' + this.tenderProjectCode + '&bidSectionCode=' + this.bidSectionCode + '&busType=' + this.businessType + "&angleType=" + angleType + "&purchaserMode=" + this.purchaserMode,
          method: 'get'
        }).then(({ data }) => {
          if (data.code == "1") {
            this.flowData = data.data;
            let nodeList = [];
            for (var key in this.flowData) {
              nodeList = nodeList.concat(JSON.parse(JSON.stringify(this.flowData[key])))
            }
            var sortList = nodeList.sort(this.compare('sort'));
            if (this.$route.query.nodeCode) {  // 页面跳转进入当前页，路由参数里有带节点编码，则匹配到此节点数据，加载此节点的表单信息
              let filterList = sortList.filter((item, index) => {
                return item.nodeCode == this.$route.query.nodeCode
              })
              filterList[0] ? this.getFormData(filterList[0]) : this.getFormData(sortList[0]);
            } else { // 路由参数无节点编码，则加载第一个节点的表单信息
              console.log(sortList[0])
              this.$nextTick(() => {
                this.getFormData(sortList[0]);
              })
            }

          } else {
            this.flowData = ''
          }
        })

        if (angleType == 3) {
          this.paramMap.applyCode = '';
          // 获取该标段 投标人集合
          this.$http({
            url: '/fileDownloads/listApply?tenderProjectCode=' + this.tenderProjectCode + '&bidSectionCode=' + this.bidSectionCode + '&busType=' + this.businessType + "&angleType=" + angleType,
            method: 'get'
          }).then(({ data }) => {
            if (data.code == "1") {
              this.applyCodeList = data.data;
            } else {
              this.applyCodeList = [];
            }
          })

        }

        if (angleType == 4) {
          this.paramMap.idcard = '';
          // 获取该标段 评标专家集合
          this.$http({
            url: '/fieldAppLys/jzTradDingParTers/listProfPerson?tenderProjectCode=' + this.tenderProjectCode + '&bidSectionCode=' + this.bidSectionCode + '&busType=' + this.businessType + "&angleType=" + angleType,
            method: 'get'
          }).then(({ data }) => {
            if (data.code == "1") {
              this.idcardOptionList = data.data;
            } else {
              this.idcardOptionList = [];
            }
          })

        }



      } else {
        this.$router.push({
          name: 'home'
        })
      }

    },
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      }
    },


  }
}
</script>


<style lang="less" scoped>
.el-dialog__wrapper /deep/ .el-dialog__header {}

.el-dialog__wrapper /deep/ .el-dialog__body {
  padding: 10px 20px;
}

.el-form /deep/ .el-form-item.single-row {
  width: 100%;
}

.el-form /deep/ .el-form-item {
  width: 50%;
  margin-bottom: 0px;
}

.el-dialog__wrapper /deep/ .el-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.site-sidebar__menu-icon {
  font-size: 20px;

}

.angleWrapper {
  border: 1px solid #dcdfe6;
  border-collapse: collapse;
  text-align: center;

  .link {
    text-decoration: none;
  }

  .link.active {
    background-color: #1965FF;
    color: white !important;
  }

  .link:hover {
    cursor: pointer;
    background-color: #1965FF;
    color: white !important;
  }
}



.angleType {
  cursor: pointer;
  width: 30px;
  height: 30px;
}

.angleType.active {
  color: #1965FF;
}

.angleType:hover {
  color: #1965FF;
}
</style>
